import { useDispatch, useSelector } from "react-redux";
import { isSavedAlbumsTextFilterReset } from "../../../../reducers/albumListState";
import { setSavedAlbumsTextFilter } from "../../../../actions/albumListActions";
import { FormControl, Input, InputLabel } from "@mui/material";
import { useDelayActionAfterTyping } from "../../../../hooks/others/useDelayActionAfterTyping";
import { useEffect } from "react";

const TextFilterInput = () => {
    const isTextFilterReset = useSelector(isSavedAlbumsTextFilterReset);
    const [textPattern, setTextPattern] = useDelayActionAfterTyping(() => dispatch(setSavedAlbumsTextFilter(textPattern))); 

    const dispatch = useDispatch();

    const onChange = (e) => {
        setTextPattern(e.target.value);
    }

    useEffect(() => {
        if(!isTextFilterReset) return;

        setTextPattern("");
    // eslint-disable-next-line
    }, [isTextFilterReset])

    return (
        <FormControl variant="standard" sx={{ minWidth: '100px', maxWidth: '150px'}} size='small'>
            <InputLabel>Search</InputLabel>
            <Input value={textPattern} onChange={onChange} />
        </FormControl>
    )
}

export default TextFilterInput;